import React, { useState, useEffect } from 'react'

import { Button, Card, Table, Typography, Icon, Input, Breadcrumb } from 'antd'

import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const ListTypes = function ({ match, history }) {
  // Settings form
  const [formatedData, setFormatedData] = useState([])
  const [formValues, setFormValues] = useState({})
  const { count, page, pageSize } = formatedData
  const { type } = match.params
  const hasAccess = validRule(RULES.MEMBER_TYPE) // Não deixa acessar a tela
  // Created component
  useEffect(() => {
    return () => {
      setFormValues({})
      setFormatedData({})
    }
  }, [])

  useEffect(() => {
    if (!hasAccess && type) {
      return history.push('/home')
    }

    listTypes(formValues)
  }, [type])

  // Api requests
  async function listTypes(params) {
    try {
      let response = {}
      const newParams = {
        ...params,
        ignoreActive: true
      }
      if (type === 'member') {
        response = await request(api.listMemberTypes(newParams))
      } else if (type === 'location') {
        response = await request(api.listTypes(newParams, type))
      }

      const itens = response.items
      const formatedRows = itens.map((item) => {
        return {
          key: item.id,
          ...item,
          actions: formatActionsContent(item.id)
        }
      })
      setFormatedData({
        ...response,
        currentPage: response.page + 1,
        items: formatedRows
        // Actions: 'teste'
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  function sortText(a, b, field) {
    if (a !== null && a[field] !== null && b !== null && b[field] !== null && field !== null) {
      if (a[field] < b[field]) return -1
      if (a[field] > b[field]) return 1
    }

    return 0
  }

  // Formaters
  const columns = [
    {
      title: getMessage('memberTypeDescription'),
      dataIndex: 'typeName',
      width: '90%',
      sorter: (a, b) => sortText(a, b, 'typeName'),
      render: (item, line) => <TableLineDisable item={item} line={line} />
    },
    {
      title: getMessage('edit'),
      dataIndex: 'actions',
      width: '10%'
    }
  ]

  function onChange(pagination) {
    const { current } = pagination
    if (current !== formatedData.currentPage) {
      listTypes({ page: current - 1, ...formValues })
    }
  }

  const formatActionsContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/types/${type}/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )

  function renderHeader() {
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          {/* <CustomBreadcrumb match={match} history={history} /> */}
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.push('/')}>
              <Icon
                type="home"
                theme="filled"
                style={{ fontSize: '16px', color: '#263447' }}
                onClick={() => history.push('/')}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Tipo de {getBrandeCub()}</Breadcrumb.Item>
          </Breadcrumb>
          {hasAccess && (
            <Button
              className="default-header-button button-action"
              type="primary"
              onClick={() => history.push(`/types/${type}/create`)}
            >
              {getMessage('storeActionTypes')}
            </Button>
          )}
        </div>
      </div>
    )
  }

  function getColumns() {
    if (validRule(RULES.MEMBER_TYPE)) {
      return columns
    }

    if (columns !== null) {
      columns.pop()
      return columns
    }
  }

  function getTitle() {
    let title = ''
    if (type === 'member') {
      title = getMessage('listMemberTypes')
    } else if (type === 'location') {
      title = getMessage('listLocationTypes')
    }

    return title
  }

  function getBrandeCub() {
    let title = ''
    if (type === 'member') {
      title = 'Profissional'
    } else if (type === 'location') {
      title = 'Local'
    }

    return title
  }

  return (
    <>
      {renderHeader()}

      <Card className="ant-card gx-card ant-card-bordered">
        <Typography.Title className="default-header-title" level={3}>
          {getTitle()}
        </Typography.Title>
        <Input.Search
          className="default-header-search"
          onSearch={(value) => listTypes({ search: value })}
          placeholder={getMessage('search')}
        />
        <Table
          key="id"
          columns={getColumns()}
          dataSource={formatedData.items}
          onChange={onChange}
          pagination={{ pageSize, current: page + 1, total: count }}
        />
      </Card>
    </>
  )
}

export default ListTypes
